import { gql } from "@apollo/client";
import { fragments as hddOrderStatusFragments } from "../../application/apps/HDDPressApp/components/HDDOrderStatus/graph";

const markOrderAsHighDefinitionDigitalPausedMutation = gql`
  mutation ($orderId: ID!) {
    markOrderAsHighDefinitionDigitalPaused(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...HDDOrderStatus_order
      }
      succeeded
    }
  }
  ${hddOrderStatusFragments.order}
`;

export default markOrderAsHighDefinitionDigitalPausedMutation;
